import React from 'react';
import * as S from './style';

function FilterTab({filterTabList, filterTabHandler, activeFilterTab, subjectsLength, userLandsOnAllPlansPage}) {
  return (
    <>
      { subjectsLength > 1 &&<S.FilterTab userLandsOnAllPlansPage={userLandsOnAllPlansPage}>
        {filterTabList.map(val =>
          <S.Filter key={val.id} isMath={val.id==='math'} active={val.id===activeFilterTab.id} onClick={()=>filterTabHandler(val)} >{val.title}</S.Filter>)}
      </S.FilterTab> }
    </>
  )
}

export default FilterTab;

